/* eslint-disable @angular-eslint/use-component-view-encapsulation */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ProcurementArea } from 'src/app/order-user/enums/procurement-area.enum';
import { getOrderLineReceiveBatchesTotal } from 'src/app/order-user/functions/get-order-line-receive-batches-total';
import { normalizeOrderQuantity } from 'src/app/order-user/functions/normalize-order-quantity';

@Component({
  selector: 'app-order-user-template',
  templateUrl: './order-user-template.component.html',
  styleUrls: ['./order-user-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class OrderUserTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };

  ProcurementArea = ProcurementArea;

  get totalReceivedQuantity(): number {
    return normalizeOrderQuantity(
      (this.element.receivedQuantity ?? 0) +
        getOrderLineReceiveBatchesTotal(this.element.addedReceivedBatches)
    );
  }
}
